import { createFileRoute, redirect } from '@tanstack/react-router';

import { ROUTES } from '@/constants/routes';

/** Users are created in the Mobile App only — the Admin Portal never adds one. */
export const Route = createFileRoute('/admin/_app/users/new')({
  beforeLoad: () => {
    throw redirect({ to: ROUTES.users, replace: true });
  },
  component: () => null,
});
